import { AuthProvider } from './auth/AuthContext';
import AppRouter from './app/router';
import './styles/app.css';

function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
